import dayjs from '~/timeInit';

/**
 * Formats a date range intelligently, avoiding repetition of year/month when they're the same
 *
 * Examples:
 * - Same year, same month: "15 Jan - 20 Jan 2024"
 * - Same year, different months: "15 Jan - 20 Feb 2024"
 * - Different years: "15 Dec 2023 - 20 Jan 2024"
 * - Single date: "15 Jan 2024"
 */
export const formatDateRange = (startDate: Date | null, endDate: Date | null): string => {
  if (!startDate) {
    return 'No start date';
  }

  if (!endDate) {
    return dayjs(startDate).format('D MMM YYYY');
  }

  const start = dayjs(startDate);
  const end = dayjs(endDate);

  // If it's the same date, just return the single date
  if (start.isSame(end, 'day')) {
    return start.format('D MMM YYYY');
  }

  // Same year and month
  if (start.isSame(end, 'year') && start.isSame(end, 'month')) {
    return `${start.format('D')} - ${end.format('D MMM YYYY')}`;
  }

  // Same year, different months
  if (start.isSame(end, 'year')) {
    return `${start.format('D MMM')} - ${end.format('D MMM YYYY')}`;
  }

  // Different years
  return `${start.format('D MMM YYYY')} - ${end.format('D MMM YYYY')}`;
};

export default formatDateRange;
